module.exports = __webpack_public_path__ + "img/jiayinsong.189a20e7.jpg";